import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { WATER_LAKE_CHL } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import MarkerLayer from './MarkerLayer'

const id = 'WaterLakeChl'
const authId = 'WaterLakeChl'
const datetimeId = 'WaterLakeChl'
const SOURCE_URL = WATER_LAKE_CHL

const layout = {
  'line-cap': 'round'
}

export class WaterLakeChl extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props    
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {      
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    const rasterSource = {
      type: 'raster',
      tiles: [SOURCE_URL({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source
          id={id}
          tileJsonSource={rasterSource}
          />,
        <Layer
          type='raster'
          id={id}
          sourceId={id}
          paint={paint}
          />
        <MarkerLayer id={id} key='MarkerLayer' />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId] || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(WaterLakeChl)



// WEBPACK FOOTER //
// ./src/layers/WaterLakeChl.js